import React, { useState } from "react";
import './ProductHeader.css';
import ProductOverlay from "../ProductOverlay";
import DatePicker from "react-datepicker";
import { FaCalendarAlt } from "react-icons/fa";

const ProductHeader = ({ search, setSearch, columnSearch, setColumnSearch, onRefresh }) => {
    const [showOverlay, setShowOverlay] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const handleRefresh = () => {
        setSearch("");
        setStartDate(null);
        setEndDate(null);
        setColumnSearch({
            status: "Active",
            productName: "",
            description: "",
            categoryName: "",
            image: "",
            mrp: "",
            sellingPrice: "",
            companyName: "",
            coins: "",
            stock: "",
            createdBy: "",
            lastUpdated: "",
        });
        if (onRefresh) {
            onRefresh();
        }
    };

    return (
        <>
            <div className="product-list-header">
                <div className="product-list-header-left">
                    <input
                        type="text"
                        placeholder="Search..."
                        value={search}
                        className="product-list-search-input"
                        onChange={(e) => setSearch(e.target.value)}
                    />

                    <div className="product-list-date-wrapper">
                        <DatePicker
                            selected={startDate}
                            onChange={(date) => {
                                setStartDate(date);
                                setColumnSearch({ ...columnSearch, startDate: date });
                            }}
                            placeholderText="Start Date"
                            dateFormat={"dd-MM-yyyy"}
                            className="product-list-date-picker"
                            popperPlacement="bottom-start"
                            showPopperArrow={false}
                            portalId="root"
                        />
                        <FaCalendarAlt className="product-list-calendar-icon" />
                    </div>

                    <div className="product-list-date-wrapper">
                        <DatePicker
                            selected={endDate}
                            onChange={(date) => {
                                setEndDate(date);
                                setColumnSearch({ ...columnSearch, endDate: date });
                            }}
                            placeholderText="End Date"
                            dateFormat={"dd-MM-yyyy"}
                            className="product-list-date-picker"
                            popperPlacement="bottom-start"
                            showPopperArrow={false}
                            portalId="root"
                        />
                        <FaCalendarAlt className="product-list-calendar-icon" />
                    </div>
                </div>

                <div className="product-list-header-right">
                    <span className="product-refresh-icon"
                        title="Refresh"
                        onClick={handleRefresh}>
                        ⟳
                    </span>
                    <span
                        className="product-add-plus"
                        onClick={() => setShowOverlay(true)}
                    >
                        +
                    </span>
                </div>
            </div>

            {showOverlay && (
                <ProductOverlay
                    onClose={() => setShowOverlay(false)}
                    onSave={
                        () => {
                            setShowOverlay(false);
                            if (onRefresh) onRefresh();
                        }
                    }
                />
            )}
        </>
    );
};

export default ProductHeader;
